export enum GLN {
	SS = '5699000021020',
	REYKJAGARDUR = '5699000021174',
	HOLLTOGGOTT = '5699000021952',
}
